// test1198
(1198 && 0);
